<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('phoneSetting') }}</h3>
      <div class="tile-body" v-if="$store.state.user.permissions.includes('phoneSetup')">
        <phone-setting></phone-setting>
        <hr>
        <route></route>
        <hr>
        <recording></recording>
        <hr>
        <MOH></MOH>
        <hr>
        <IVR></IVR>
        <hr>
        <queue></queue>
        <hr>
        <time-condition></time-condition>
        <hr>
        <announcement></announcement>
        <hr>
        <a-p-i-route></a-p-i-route>
      </div>
      <div class="tile-body text-center" v-else>
        <h5>{{$t('noPermission')}}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import Recording from "./Recording";
import MOH from "./MOH";
import Queue from "./Queue";
import IVR from "./IVR";
import PhoneSetting from "./PhoneSetting";
import Route from "./Route";
import TimeCondition from "./TimeConditions";
import Announcement from "@/views/setting/communication/phone/Announcement";
import APIRoute from "@/views/setting/communication/phone/APIRoute";

export default {
  components: {APIRoute, Announcement, TimeCondition, IVR, PhoneSetting, Recording, Queue, Route, MOH},
}
</script>